import React from 'react'
import { Container, Navbar } from 'react-bootstrap'
import { A } from 'hookrouter'
import { Logo } from 'components/Logo'

export const NotFound = () => {
  return (
    <div className="content">
      <Navbar expand="lg">
        <Navbar.Brand as={A} href="/">
          <Logo />
        </Navbar.Brand>
      </Navbar>
      <Container fluid>
        <h1> We're sorry, this page doesn't exist. Please try another Path!</h1>
      </Container>
    </div>
  )
}
